import axios from "axios";
import logger from "../lib/logger";

const baseDomain = location.origin;
const baseURL = `${baseDomain}/kawabou/file/gjson`;

const http = axios.create({
  baseURL,
});

http.interceptors.response.use(
  (response) => {
    return Promise.resolve({
      data: response.data,
    });
  },
  (error) => {
    logger.error("[MapRepository]API response faild");
    return Promise.resolve({
      error: error.response,
    });
  }
);
export default http;
